import Utils from "../utils/utils"
const utilsHelper = new Utils()

export default class IframeMessageListener{
    constructor(container_id, config, is_debug){
        this.container_id = container_id
        this.config = config
        this.platform = utilsHelper.checkPlatform()
        this.is_debug = is_debug
        // console.log('IframeMessageListener_init',this.config)
    }

    start() {
        let that = this
        window.addEventListener('message', function(event){
            that.getIframeMessage(event,that)
        })

        try {
            let iframe_redirect = sessionStorage.getItem('opt99_iframe_redirect')
            if (iframe_redirect) {

                let user_data = null
                if (this.platform === 'shopline') {
                    user_data = utilsHelper.getShoplineUserData()
                }
                else if (this.platform === 'cyberbiz') {
                    user_data = utilsHelper.getCyberbizUserData()
                }
                else if (this.platform === '91app') {
                    user_data = utilsHelper.get91AppUserData()
                }
    
                if (!user_data) {
                    sessionStorage.removeItem('opt99_iframe_redirect')
                    return
                }

                try {
                    iframe_redirect = new URL(iframe_redirect)
                    sessionStorage.removeItem('opt99_iframe_redirect')
                    if (iframe_redirect.pathname !== window.location.pathname) {
                        window.location.href = iframe_redirect.href
                    }
                } catch (error) {
                    console.log('iframe_redirect_error_2',error)
                    sessionStorage.removeItem('opt99_iframe_redirect')
                }
            }
        } catch (error) {
            console.log('iframe_redirect_error_1',error)
            sessionStorage.removeItem('opt99_iframe_redirect')
        }

        // iframe allow權限回寫
        try {
            let ict_iframes = Array.from(document.querySelectorAll(`iframe[src^="https://${this.config.DOMAIN}/embed/invoice_collector"],iframe[data-src^="https://${this.config.DOMAIN}/embed/invoice_collector"]`))
            console.log('ict_frames', ict_iframes)
            ict_iframes.forEach(function(ict_iframe){
                ict_iframe.setAttribute('allow', 'camera *')
                ict_iframe.replaceWith(ict_iframe)
                // ict_iframe.setAttribute('scrolling', "no")
            })
        } catch (error) {
            console.log('iframe_allow_error', error)
        }
    }

    getIframeMessage(event, that) {
        // console.log('callback_event', event)
        // console.log('container_id', that.container_id)
        // console.log('config',that.config)
        // console.log('this',that)
        // console.log('event.origin',event.origin)
        // console.log('that.config.DOMAIN',that.config.DOMAIN)
        // console.log('is_pass',event.origin.includes(that.config.DOMAIN))
        if (event.origin.includes(that.config.DOMAIN) === false) {
            console.log('opt99_message_domain_filter')
            return
        }
        
        

        const resp_data = event.data
        console.log('resp_data',resp_data)
        console.log('that.container_id ',that.container_id )
        if (that.container_id !== resp_data.container_id) {
            console.log('opt99_message_container_filter')
            return
        }

        switch (resp_data.feature) {
            case 'invoice_collector':
                that.invoiceCollectorCallback(resp_data, event)
                break;
            default:
                console.log('unknown_callback')
        }

    }

    invoiceCollectorCallback(data, event){
        console.log('ict_event',event)
        console.log('ict_data',data)
        console.log('url1',data.url)
        if (data.action === 'send_pixel') {
            console.log('ict_pixel')
            let event_name = data.data.event
            window.fbq('track', event_name);
        }
        else if(data.action === 'login') {

            let user_data = null
            if (this.platform === 'shopline') {
                user_data = utilsHelper.getShoplineUserData()
            }
            else if (this.platform === 'cyberbiz') {
                user_data = utilsHelper.getCyberbizUserData()
            }
            else if (this.platform === '91app') {
                user_data = utilsHelper.get91AppUserData()
            }

            if (user_data) {
                console.log('user_data',user_data)
                console.log('data',data)
                console.log('url2',data.url)
                let iframe_url = data.url
                let from_iframe = document.querySelector(`iframe[src*="${iframe_url}"]`)
                console.log('from_iframe',from_iframe)
                let params = {
                    action: 'login_callback',
                    data: user_data
                }
                from_iframe.contentWindow.postMessage(params, '*')
            }
            else {
                if (data.is_redirect) {
                    console.log('no_login')
                    sessionStorage.setItem('opt99_iframe_redirect', window.location.href)
                    
                    let login_url = ''
                    if (this.platform === 'shopline') {
                        login_url = `${window.location.protocol}//${window.location.hostname}/users/sign_in`
                    }
                    else if(this.platform === 'cyberbiz') {
                        login_url = `${window.location.protocol}//${window.location.hostname}/account/login` 
                    }
                    else if (this.platform === '91app') {
                        login_url = `${window.location.protocol}//${window.location.hostname}/V2/Login/Index/`  
                    }

                    window.location.href = login_url 

                }
            }

        }
    }
}